var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle1D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_hair:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31__2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M412.5,104.9C412.6,104.9,412.6,104.8,412.5,104.9C412.6,104.8,412.5,104.9,412.5,104.9 C412.3,105,412.3,105.1,412.5,104.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M465.2,177.3c-1.4-4.3-3.2-8.2-7.1-10.9c5.4-1.8,14.5-1.8,20,0.8c-1.7-9.1-12.5-11.1-20.6-11.9 c5.3-7.7,3.5-18.6-1.6-26.6c-1.4,5.3-4.5,10.1-9.2,13.8c8.4-19.4,3.5-48.4-17.5-59c-0.1,9-8.1,18.8-16.7,21.4c0,0,0,0,0,0.1 c-0.2,0.2-0.2,0.2,0,0c0,0,0,0,0.1,0c9.1-11.1,1.8-24.6-9.4-32.1c-1.3,11.4-9.6,23.7-20.2,29.5c2.8-9.8,0.6-27.1-10.4-33.1 c-1.8,13.6-19.1,20.9-30.6,24.8c-16.2,5.5-34.9,4.8-51.1,10.6c-16.6,6-30.6,22.1-28.6,38.3c-4-6.1-7.9-11.6-4.8-18.6 c-13.8,8.5-19.8,28.9-9.3,40.4c-13.2,6.1-12,20.1-10.4,32.2c2.2,16.5,7.7,36.3,17.7,54.3c1,1.8,3.4,7.7,4.5,9.3 c-1.4-14.1,3.2-42,5.9-56.7c2.8-15.6,5.1-30.5,24.4-31.7c9.8-0.6,21.1,3.2,30.3,4.8c8.4,1.4,23,3.2,32,2.7 c17.6-1,28.1-4.5,42.7-8.8c20.3-5.9,19.7-7.5,32,8.2c11.2,14.4,18.6,42.8,20.2,59.8c1,10,1.8,22,6.3,30.1 C455.3,241.1,479.6,221.5,465.2,177.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6F615E",
    d: "M412.5,104.9C412.6,104.9,412.6,104.8,412.5,104.9C412.6,104.8,412.5,104.9,412.5,104.9 C412.3,105,412.3,105.1,412.5,104.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F615E",
    d: "M424.8,163.2c13.9,1,32.1-12.9,35-25.6c-0.8-3.2-2.2-6.2-3.9-8.9c-1.4,5.3-4.5,10.1-9.2,13.8 c0-0.1,0.1-0.1,0.1-0.2C441.2,151.4,433,161.3,424.8,163.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F615E",
    d: "M424.8,163.2L424.8,163.2L424.8,163.2C424.5,163.2,424.5,163.2,424.8,163.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F615E",
    d: "M427.9,118.3c-14.1,13.6-31,21.5-50.3,25.4c-22.4,4.5-44.1,0.2-66.7-1.1c-10.5-0.6-20.5,0.8-29.7,5.7 c-5.7,3.1-15.2,9.6-17.7,16.4c5.9-5,12.5-7.9,21.6-8.2c19.5-0.6,37.4,5.3,56.7,5.3c20.8,0,41.2-1.1,59-12 c13.8-8.5,29.9-24.2,33.2-39.7C432.9,113.2,430.4,116,427.9,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F615E",
    d: "M359.6,105.7c9.6-8.8,17-21.8,16.1-34.3c-0.9-0.8-2-1.6-3.1-2.2c-0.1,1.1-0.4,2.1-0.7,3 c-0.2,1.8-0.5,3.4-1.3,5.3c-3,7.9-9,15.2-16.5,20.2c-9.6,6.4-23.1,8.2-34.5,9.6c-11.8,1.4-24.3,4.3-35.8,7.1 c-9.1,2.3-14.6,7.4-19.4,14.1c-1.2,2.7-1.9,5.6-2.2,8.4c11.5-11.2,31.5-12.8,46.6-15.4C324.9,119,347.1,117.2,359.6,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F615E",
    d: "M297.2,137.2c2.9-0.6,5.8-1,8.7-1.4c32.9-3.4,76.7-1.3,93.9-32.8c1.3-2.4,2.3-5.1,3-7.9 c-1.5,2.3-3.1,4.5-4.9,6.5c-22,23.3-56.9,22.3-87.3,25.5c-3,0.4-6,1-8.9,1.6c-16.8,3.5-32.1,10.5-39.2,26.4 C271.9,144.8,284.1,139.9,297.2,137.2z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle1D);
export default __webpack_public_path__ + "static/media/man_hairstyle_1d.793eb731785d931bb737f624a8bd235e.svg";
export { ForwardRef as ReactComponent };